import { Facets, IndexedChannelInfo, SelectedFacet } from '@lessonup/typescript-core/domain';
import { TFunction } from 'i18next';

export default function generateMetaDescription(
  selectedFacets: SelectedFacet[],
  count: number | undefined,
  type: 'lessons' | 'plans',
  t: TFunction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  channelInfo?: IndexedChannelInfo
): string {
  if (!selectedFacets.length) return type === 'lessons' ? t('lessonsMetaFallback') : t('plansMetaFallback');

  const { schoolType, yearAndLevel, subject } = Facets.obtainMetaDataInfoForSelectedFacets(selectedFacets);

  let description =
    t('metaLookingFor', { subject: subject || schoolType || '' }) +
    ' ' +
    t(type === 'lessons' ? 'metaDescriptionContentLessons' : 'metaDescriptionContentPlans', {
      subject: subject || '',
      count,
      formattedCount: count && count.toLocaleString(),
    });

  if (schoolType) description += ' ' + schoolType.toLowerCase();
  if (yearAndLevel) description += ' ' + yearAndLevel;
  return description + '.';
}
